/*#__PURE__*/ /* eslint-disable no-invalid-this */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { getUpdateStateDetails, getUpdateStateTx } from "./helpers/index";
import { RPCMethods } from "./types";
const sendSnapMethod = function() {
    var _ref = _async_to_generator(function*(request, snapId) {
        return yield window.ethereum.request({
            method: 'wallet_invokeSnap',
            params: {
                request: _object_spread({
                    method: request.method
                }, request.params && {
                    params: request.params
                }),
                snapId
            }
        });
    });
    return function sendSnapMethod(request, snapId) {
        return _ref.apply(this, arguments);
    };
}();
export const checkCredentialExistence = function() {
    var _ref = _async_to_generator(function*(params) {
        return yield sendSnapMethod({
            method: RPCMethods.CheckCredentialExistence,
            params
        }, this.snapId);
    });
    return function checkCredentialExistence(params) {
        return _ref.apply(this, arguments);
    };
}();
export const createIdentity = function() {
    var _ref = _async_to_generator(function*(params) {
        return yield sendSnapMethod({
            method: RPCMethods.CreateIdentity,
            params
        }, this.snapId);
    });
    return function createIdentity(params) {
        return _ref.apply(this, arguments);
    };
}();
export const getIdentity = function() {
    var _ref = _async_to_generator(function*() {
        return yield sendSnapMethod({
            method: RPCMethods.GetIdentity
        }, this.snapId);
    });
    return function getIdentity() {
        return _ref.apply(this, arguments);
    };
}();
export const saveCredentials = function() {
    var _ref = _async_to_generator(function*(params) {
        return yield sendSnapMethod({
            method: RPCMethods.SaveCredentials,
            params
        }, this.snapId);
    });
    return function saveCredentials(params) {
        return _ref.apply(this, arguments);
    };
}();
export const removeCredentials = function() {
    var _ref = _async_to_generator(function*(params) {
        return yield sendSnapMethod({
            method: RPCMethods.RemoveCredentials,
            params
        }, this.snapId);
    });
    return function removeCredentials(params) {
        return _ref.apply(this, arguments);
    };
}();
export const createProof = function() {
    var _ref = _async_to_generator(function*(params) {
        const snapResponse = yield sendSnapMethod({
            method: RPCMethods.CreateProof,
            params
        }, this.snapId);
        const updateStateDetails = yield getUpdateStateDetails(snapResponse.stateData, snapResponse.operation, snapResponse.rarimoCoreUrl);
        let updateStateTx;
        if (!snapResponse.isSynced) {
            updateStateTx = yield getUpdateStateTx(params.accountAddress, snapResponse.chainInfo, snapResponse.stateData, snapResponse.operation, snapResponse.rarimoCoreUrl, updateStateDetails);
        }
        return _object_spread({
            statesMerkleData: {
                issuerId: snapResponse.issuerHexId,
                state: snapResponse.stateData,
                merkleProof: snapResponse.merkleProof.proof
            },
            zkpProof: snapResponse.zkpProof,
            updateStateDetails
        }, updateStateTx && {
            updateStateTx
        });
    });
    return function createProof(params) {
        return _ref.apply(this, arguments);
    };
}();
export const checkStateContractSync = function() {
    var _ref = _async_to_generator(function*() {
        return yield sendSnapMethod({
            method: RPCMethods.CheckStateContractSync
        }, this.snapId);
    });
    return function checkStateContractSync() {
        return _ref.apply(this, arguments);
    };
}();
export const getCredentials = function() {
    var _ref = _async_to_generator(function*() {
        return yield sendSnapMethod({
            method: RPCMethods.GetCredentials
        }, this.snapId);
    });
    return function getCredentials() {
        return _ref.apply(this, arguments);
    };
}();
export const exportIdentity = function() {
    var _ref = _async_to_generator(function*() {
        return yield sendSnapMethod({
            method: RPCMethods.ExportIdentity
        }, this.snapId);
    });
    return function exportIdentity() {
        return _ref.apply(this, arguments);
    };
}();

//# sourceMappingURL=methods.js.map